// Imports
import Axios from 'axios'

// Axios Config
const AxiosConfig = Axios.create({
  baseURL: 'https://api.lens.foreplay.co'
})

export default AxiosConfig
